import { render, staticRenderFns } from "./PaymentsOtrosPagos.vue?vue&type=template&id=00066243&scoped=true&"
import script from "./PaymentsOtrosPagos.vue?vue&type=script&lang=js&"
export * from "./PaymentsOtrosPagos.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsOtrosPagos.vue?vue&type=style&index=0&id=00066243&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00066243",
  null
  
)

export default component.exports